<cdk-virtual-scroll-viewport
  id="inquiryScrollableDays"
  class="inquiry-scrollable-days"
  orientation="horizontal"
  [itemSize]="dayColumnWidth"
  [minBufferPx]="dayColumnWidth * 1.5"
  [maxBufferPx]="dayColumnWidth * 1.75"
  baseInquiryHorizontalScroll
  [trackList]="offer.dates"
>
  <div
    class="day-container"
    [ngClass]="{ 'calendar-weekend': dateItem.isWeekend, today: dateItem.isToday }"
    *cdkVirtualFor="let dateItem of offer.dates; trackBy: trackByDate"
  >
    <div
      class="calendar-column"
      *ngFor="let shiftItem of dateItem.shifts; trackBy: trackByShift"
    >
      <base-customer-offer-bubble
        [bubble]="shiftItem"
        [isOfferSelected]="offer.data.isSelected"
        (bubbleClick)="onBubbleClick(offer.data.id, shiftItem, dateItem.date)"
      ></base-customer-offer-bubble>
    </div>
  </div>
</cdk-virtual-scroll-viewport>
